import React from 'react';
import Select from 'react-select';

export default ({ onChange, options, value, className}) => {

    const defaultValue = (options, value) => {
       
        var x = options ? options.find(option => option.value === value) : "";      
        return x;
    };

    return (
        <div className={className}>
            <Select
                value={defaultValue(options, value) || ''}
                onChange={value => {
                    onChange(value)

                }} options={options}
                />
        </div>

    )
}